import { Controller } from '@hotwired/stimulus';
import 'arrive/src/arrive';
import { bpHelper } from '../../components/utils';

export default class extends Controller {
  static values = {
    modalLinkId: String,
  };

  static targets = [
    'form',
    'baseError',
    'radioFoundHere',
    'radioSomewhereElse',
    'radioSomewhereElseReasons',
    'radioNotFound',
    'radioOther',
    'radioList',
    'inputFoundHere',
    'inputSomewhereElse',
    'inputSomewhereElseReasons',
    'inputNotFound',
    'inputOther',
    'inputList',
    'containerFoundHere',
    'containerSomewhereElse',
    'containerOther',
    'containerList',
    'ratingSelect',
    'ratingInNumber',
    'ratingContainer',
    'commentOther',
  ];

  connect() {
    this.subRadioButtonList = this.radioSomewhereElseReasonsTarget.querySelectorAll('.form-check');
    this.deleteButtonTarget = this.formTarget.querySelector(`#${this.modalLinkIdValue}`);

    const that = this;
    this.ratingContainerTarget.arrive('.br-widget', () => {
      that.stars = that.ratingContainerTarget.getElementsByTagName('a');
      that.setListenerForStars();
    });

    if (this.hasBaseErrorTarget) {
      this.resetForm();
    }

    this.setRatingCount();
    this.addListenerToSubRadioButton();
  }

  // for animations
  showFoundHereForm() {
    this.showReasonForm(
      this.radioFoundHereTarget,
      this.inputFoundHereTarget,
      this.containerFoundHereTarget,
      'found_here'
    );
  }

  showSomewhereElseForm() {
    this.showReasonForm(
      this.radioSomewhereElseTarget,
      this.inputSomewhereElseTarget,
      this.containerSomewhereElseTarget,
      'somewhere_else'
    );
  }

  showNotFoundForm() {
    this.showReasonForm(
      this.radioNotFoundTarget,
      this.inputNotFoundTarget,
      null,
      'not_found'
    );
  }

  showOtherForm() {
    this.showReasonForm(
      this.radioOtherTarget,
      this.inputOtherTarget,
      this.containerOtherTarget,
      'other'
    );
  }

  // hack to check radio buttons in mobile (offcanvas does not check radio buttons properly)
  // set listeners in somewhere_else form radios
  addListenerToSubRadioButton() {
    this.inputSomewhereElseReasonsTargets.forEach(input => {
      const label = input.parentElement.querySelector('LABEL');
      label.addEventListener('click', () => {
        this.uncheckAllRadioButtons(this.subRadioButtonList, this.inputSomewhereElseReasonsTargets);
        input.setAttribute('checked', 'checked');
        input.parentElement.classList.remove('unchecked');
        input.parentElement.classList.add('checked');
      });
    });
  }

  uncheckAllRadioButtons(radioList, inputList) {
    radioList.forEach(radio => {
      radio.classList.add('unchecked');
      radio.classList.remove('checked');
    });

    inputList.forEach(input => {
      input.removeAttribute('checked');
    });
  }

  checkRadio(radioTarget, inputTarget) {
    this.uncheckAllRadioButtons(this.radioListTargets, this.inputListTargets);
    radioTarget.classList.add('checked');
    inputTarget.setAttribute('checked', 'checked');
  }

  hideUncheckedReviewForms(checkedReasonFormContainer = null) {
    this.containerListTargets.forEach((container) => {
      if (container !== checkedReasonFormContainer) {
        this.playShrinkAnimation(container);
      }
    });
  }

  resetForm() {
    this.uncheckAllRadioButtons(this.radioListTargets, this.inputListTargets);
    this.hideUncheckedReviewForms();
  }

  showReasonForm(radio, input, container, reason) {
    if (bpHelper.isMatching('md', true)) { this.checkRadio(radio, input); }
    this.playExpandAnimation(container);
    this.hideUncheckedReviewForms(container);
    this.checkForms(reason);
  }

  playShrinkAnimation(container) {
    if (container === null) { return; }
    container.classList.remove('expand');
    container.classList.add('shrink');
  }

  playExpandAnimation(container) {
    if (container === null) { return; }
    container.classList.remove('shrink');
    container.classList.add('expand');
  }

  // for rating logic
  setListenerForStars() {
    const callSetRatingCount = () => {
      this.setRatingCount();
    };

    for (let i = 0; i < this.stars.length; i++) {
      if (bpHelper.isMatching('md', true)) {
        this.stars[i].removeEventListener('touchend', callSetRatingCount);
        this.stars[i].addEventListener('touchend', callSetRatingCount);
      } else {
        this.stars[i].removeEventListener('click', callSetRatingCount);
        this.stars[i].addEventListener('click', callSetRatingCount);
      }
    }
  }

  getRating() {
    const rating = this.ratingSelectTarget.selectedIndex;
    if (rating === 0) {
      return '-';
    } else {
      return this.ratingSelectTarget.selectedIndex;
    }
  }

  setRatingCount() {
    this.ratingInNumberTarget.innerText = `(${this.getRating()})`;
    this.checkForms('found_here');
  }

  // for delete button logic
  disableDeleteButton() {
    this.deleteButtonTarget.classList.add('btn--disabled');
    this.deleteButtonTarget.setAttribute('disabled', 'true');
  }

  enableDeleteButton() {
    this.deleteButtonTarget.classList.remove('btn--disabled');
    this.deleteButtonTarget.removeAttribute('disabled');
  }

  checkFoundHereCommentLength() {
    // unused but necessary to avoid no method error
  }

  checkOtherCommentLength() {
    this.checkForms('other');
  }

  enableOrDisableDeleteButton(condition) {
    if (condition) {
      this.enableDeleteButton();
    } else {
      this.disableDeleteButton();
    }
  }

  checkForms(reason) {
    switch (reason) {
      case 'found_here':
        this.enableOrDisableDeleteButton(this.getRating() > 0);
        break;
      case 'somewhere_else':
        this.enableDeleteButton();
        break;
      case 'not_found':
        this.enableDeleteButton();
        break;
      case 'other':
        this.enableOrDisableDeleteButton(this.commentOtherTarget.value.replace(/\s+/g, '').length >= 20);
        break;
      default:
        this.disableDeleteButton();
        break;
    }
  }
};
